<style lang="scss" scoped>

</style>

<template>
<div class="page-container">
  <slot></slot>
  <footer>
    <mw-footer />
  </footer>
</div>
</template>

<script>
import MwFooter from '@/components/elements/footer'

export default {
  name: 'BasicLayout',
  components: { MwFooter }
}
</script>
